export const ENVIRONMENT = {
	baseURL: '',
};
